import * as React from "react";
import { RadiosEditor } from "../../../../../../../../react-core/Html/RadiosEditor";
import { isNullOrEmpty } from "../../../../../../../../react-core/Utils/Arrays";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SourceType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SourceType";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { MoneyOrPercentage } from "../../../../../../../../Wrap/Models/Models/Shared/MoneyOrPercentage";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { AdviserChargesContents } from "../../../../Common/AdviserCharges/Resource/Contents";
import { ChargesHelper } from "../../../../Common/Helpers/ChargesHelper";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";

interface IChargesCopyOptionProps extends IProcessComponentProps {}

interface IChargesCopyOptionState {}

export class ChargesCopyOption extends ProcessComponent<IChargesCopyOptionProps, IChargesCopyOptionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();
        const { data, onChange } = this.props;
        if (isNullOrEmpty(data.GiaQuote.ChargesExtraInfo?.CopyChargesFromOtherWizard)) {
            if (!data.GiaQuote.ChargesExtraInfo) {
                data.GiaQuote.ChargesExtraInfo = { CopyChargesFromOtherWizard: false };
            } else {
                data.GiaQuote.ChargesExtraInfo.CopyChargesFromOtherWizard = false;
            }
        }
        onChange(data);
    }

    copyCharges(source: SubAccountType, v: boolean) {
        const { data, onChange } = this.props;
        data.GiaQuote.ChargesExtraInfo.CopyChargesFromOtherWizard = v;
        if (v) {
            if (SubAccountTypeHelper.isOnPlatformPension(source)) {
                if (ChargesHelper.displayIAC(data.GiaQuote, SubAccountType.PersonalPortfolio)) {
                    const iac = data.PensionQuote.InitialAdviserCharge;
                    iac.SourceType = SourceType.WrapCash;
                    data.GiaQuote.InitialAdviserCharge = iac;
                }
                const oac = data.PensionQuote.OngoingAdviceCharge;
                oac.SourceType = SourceType.WrapCash;
                data.GiaQuote.OngoingAdviceCharge = oac;
            } else if (source === SubAccountType.StocksIsa) {
                if (ChargesHelper.displayIAC(data.GiaQuote, SubAccountType.PersonalPortfolio)) {
                    data.GiaQuote.InitialAdviserCharge = data.IsaModel.InitialAdviserCharge;
                }
                data.GiaQuote.OngoingAdviceCharge = data.IsaModel.OngoingAdviceCharge;
            }
        } else {
            data.GiaQuote.InitialAdviserCharge = this.emptyPercentageOrMoney();
            data.GiaQuote.OngoingAdviceCharge = this.emptyPercentageOrMoney();
        }
        onChange(data);
    }

    emptyPercentageOrMoney(): MoneyOrPercentage {
        return {
            Type: null,
            Money: { Amount: null, Currency: CurrencyCode.GBP },
            Percentage: null,
            Frequency: null,
            SourceType: null,
        };
    }

    getSourceToCopy(): SubAccountType {
        const { data } = this.props;
        const sippProvided = ChargesHelper.chargesProvided(data.PensionQuote);
        const isaProvided = ChargesHelper.chargesProvided(data.IsaModel);
        return sippProvided ? SubAccountType.Sipp : isaProvided ? SubAccountType.StocksIsa : null;
    }

    public render(): JSX.Element {
        const source = this.getSourceToCopy();
        if (!source) {
            return null;
        }
        const label = SubAccountTypeHelper.isOnPlatformPension(source)
            ? AdviserChargesContents.CopyFromSipp
            : AdviserChargesContents.CopyFromIsa;
        return (
            <>
                <RadiosEditor
                    cssWrapper="rg-150 mb-24"
                    label={label}
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    selected={this.props.data?.GiaQuote?.ChargesExtraInfo?.CopyChargesFromOtherWizard}
                    onChange={(v) => this.copyCharges(source, v)}
                />
            </>
        );
    }
}
